import { GraphQLError } from 'graphql/error/GraphQLError'
import router from '@/router'

export type ErrorCode = string // TODO 'system.error' | 'system.resource-not-found'

export type ErrorHandler = (
  errorCode: ErrorCode,
  error: GraphQLError
) => GraphQLError | undefined

const defaultHandler: ErrorHandler = (_, error) => error

/**
 * @returns {GraphQLError[]} unhandled errors
 */
export default function userHandler(
  graphQLErrors: ReadonlyArray<GraphQLError>,
  handler: ErrorHandler = defaultHandler
): GraphQLError[] {
  return graphQLErrors.reduce((acc, error) => {
    const unHandledError = handler(error.extensions?.code, error)
    return unHandledError ? [...acc, unHandledError] : acc
  }, new Array<GraphQLError>())
}

/**
 * Concrete Handlers
 */

export const resourceNotFoundHandler: ErrorHandler = (code, error) => {
  if (code === 'system.resource-not-found') {
    router.push({ name: 'NotFound' })
    return undefined
  }
  return error
}
